"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const models_1 = require("./generated/client/models");
/**
 * Component for table field
 */
class MetaformTableFieldComponent extends react_1.default.Component {
    /**
     * Constructor
     *
     * @param props component props
     */
    constructor(props) {
        super(props);
        /**
         * Renders table header
         */
        this.renderHeader = () => {
            const columns = this.props.field.columns || [];
            return (react_1.default.createElement("thead", null,
                react_1.default.createElement("tr", null, columns.map(this.renderHeaderColumn))));
        };
        /**
         * Renders table header column
         *
         * @param column column
         */
        this.renderHeaderColumn = (column) => {
            return (react_1.default.createElement("th", { style: { textAlign: "left" }, key: column.name },
                " ",
                column.title || "",
                " "));
        };
        /**
         * Renders table body
         */
        this.renderBody = () => {
            const rowValues = this.getRowValues();
            return (react_1.default.createElement("tbody", null, rowValues.map((rowValue, rowNumber) => this.renderRow(rowNumber, rowValue))));
        };
        /**
         * Renders an add row button
         */
        this.renderAddRowButton = () => {
            if (this.props.field.addRows === false) {
                return null;
            }
            if (this.props.formReadOnly || this.props.field.readonly) {
                return null;
            }
            return (react_1.default.createElement("a", { style: { cursor: "pointer" }, onClick: this.onAddRowButtonClick },
                this.props.renderIcon("add", "add"),
                react_1.default.createElement("span", { style: { verticalAlign: "super" } },
                    this.props.strings.tableField.addNewRow,
                    " ")));
        };
        /**
         * Renders row element
         *
         * @param rowNumber row number
         * @param rowValue row value
         */
        this.renderRow = (rowNumber, rowValue) => {
            const columns = this.props.field.columns || [];
            return (react_1.default.createElement("tr", { key: rowNumber }, columns.map(column => {
                return this.renderCell(rowNumber, column, rowValue[column.name] || null);
            })));
        };
        /**
         * Renders cell element
         *
         * @param rowNumber row number
         * @param column column
         * @param value value
         */
        this.renderCell = (rowNumber, column, value) => {
            return (react_1.default.createElement("td", { key: column.name }, this.renderCellInput(rowNumber, column, value)));
        };
        /**
         * Renders cell input element
         *
         * @param rowNumber row number
         * @param column column
         * @param value value
         */
        this.renderCellInput = (rowNumber, column, value) => {
            switch (column.type) {
                case models_1.MetaformTableColumnType.Text:
                    return this.renderCellInputText(rowNumber, column, value);
                case models_1.MetaformTableColumnType.Number:
                    return this.renderCellInputNumber(rowNumber, column, value);
                default:
                    return react_1.default.createElement("div", { style: { color: "red" } },
                        " Unknown column type ",
                        column.type,
                        "\u00A0");
            }
        };
        /**
         * Renders text cell input element
         *
         * @param rowNumber row number
         * @param column column
         * @param value value
         */
        this.renderCellInputText = (rowNumber, column, value) => {
            return (react_1.default.createElement("input", { value: value || "", key: column.name, style: { width: "100%", padding: 5 }, readOnly: this.props.formReadOnly || this.props.field.readonly, onChange: (event) => this.onCellInputTextChange(rowNumber, column, event.target.value) }));
        };
        /**
         * Renders number cell input element
         *
         * @param rowNumber row number
         * @param column column
         * @param value value
         */
        this.renderCellInputNumber = (rowNumber, column, value) => {
            return (react_1.default.createElement("input", { value: value || "", type: "number", key: column.name, style: { width: "100%", padding: 5 }, readOnly: this.props.formReadOnly || this.props.field.readonly, onChange: (event) => this.onCellInputNumberChange(rowNumber, column, event.target.value) }));
        };
        /**
         * Sets cell value
         *
         * @param rowNumber row number
         * @param column column
         * @param value new value
         */
        this.setTableFieldCellValue = (rowNumber, column, value) => {
            const rowValues = this.getRowValues();
            const rowValue = Object.assign({}, rowValues[rowNumber] || {});
            rowValue[column.name] = value;
            rowValues[rowNumber] = rowValue;
            this.props.onValueChange(rowValues);
        };
        /**
         * Returns deserialized row values
         *
         * @returns deserialized row values
         */
        this.getRowValues = () => {
            const value = this.props.value;
            if (!value) {
                return this.props.formReadOnly ? [] : [{}];
            }
            if (typeof value === "string") {
                return JSON.parse(value);
            }
            return value;
        };
        /**
         * Event handler for field input change
         *
         * @param event event
         */
        this.onCellInputTextChange = (rowNumber, column, value) => {
            this.setTableFieldCellValue(rowNumber, column, value);
        };
        /**
         * Event handler for field input change
         *
         * @param event event
         */
        this.onCellInputNumberChange = (rowNumber, column, value) => {
            this.setTableFieldCellValue(rowNumber, column, parseFloat(value));
        };
        /**
         * Event handler for add button click
         */
        this.onAddRowButtonClick = () => {
            const rowValues = this.getRowValues();
            rowValues.push({});
            this.props.onValueChange(rowValues);
        };
        this.state = {};
    }
    /**
     * Component render method
     */
    render() {
        if (!this.props.field.name) {
            return null;
        }
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("table", { style: { width: "100%" } },
                this.renderHeader(),
                this.renderBody()),
            react_1.default.createElement("div", null, this.renderAddRowButton())));
    }
}
exports.MetaformTableFieldComponent = MetaformTableFieldComponent;
//# sourceMappingURL=data:application/json;base64,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